import React from 'react';
import {
  FileIconPdf,
  FileIconMov,
  FileIconRvt,
  FileIconZip,
  FileIconFile,
} from 'icons';
import { AttachmentFile } from './fileList.types';
import * as Styled from './FilesList.styles';

interface FileItemProps {
  item: AttachmentFile;
  downloadButtonLabel?: string;
  onDonwoadFileClick: (e: React.SyntheticEvent) => void;
  onFileClick: (e: React.SyntheticEvent) => void;
}

export const FileItem: React.FC<FileItemProps> = ({
  item,
  downloadButtonLabel,
  onFileClick,
  onDonwoadFileClick,
}) => (
  <Styled.FileLink key={item.id}>
    <Styled.InnerWrapper
      href={item.url}
      title={item.name}
      onClick={onFileClick}
    >
      <Styled.IconWrapper>{getFileIcon(item.file_type)}</Styled.IconWrapper>
      <Styled.FileInfo>
        <Styled.FileDescription variant="tiny">
          {item.name}
        </Styled.FileDescription>
        <Styled.FileTitle variant="tiny">{item.description}</Styled.FileTitle>
      </Styled.FileInfo>
    </Styled.InnerWrapper>
    <Styled.FileData onClick={onDonwoadFileClick}>
      {formatFileSizeMB(item.file_size)} ·{' '}
      <span>{downloadButtonLabel || 'Download'}</span>
    </Styled.FileData>
  </Styled.FileLink>
);

////
function formatFileSizeMB(sizeInBytes: number): string {
  return `${Math.max(0.1, sizeInBytes / 1024 ** 2).toFixed(1)} MB`;
}

export const getAnalyticsItemType = (item: any) => {
  if (!item) {
    return null;
  }

  const productFinishTypeValue =
    item.productFinishType ?? item.product_finish_type;
  if (productFinishTypeValue?.toLowerCase().includes('product')) {
    return 'Non sampleable';
  } else if (productFinishTypeValue?.toLowerCase().includes('finish')) {
    return 'Finish';
  }

  return 'Sampleable';
};

const icons: Record<string, JSX.Element> = {
  pdf: <FileIconPdf />,
  mov: <FileIconMov />,
  rvt: <FileIconRvt />,
  zip: <FileIconZip />,
};

/**
 * Returns the appropriate file icon based on the file type.
 * @param type - The file type.
 * @returns The corresponding file icon component.
 */
const getFileIcon = (type = '') => {
  return icons[`${type?.toLowerCase()}`] || <FileIconFile />;
};
